import styled from 'styled-components';

import { basicCaptionTextStyle } from '@dreryk/react-components';

type StyledAnxiolyticProps = { color: string };

const StyledAnxiolytic = styled.span<StyledAnxiolyticProps>`
   color: ${(props) => props.color};
   padding-left: 2px;
   vertical-align: text-top;
   ${basicCaptionTextStyle};
`;

StyledAnxiolytic.displayName = 'StyledAnxiolytic';

export { StyledAnxiolytic };
